
<template>
    <component :is="view" v-on:abbort="$emit('abbort')" v-on:stepdone="$emit('stepdone', '2')"> </component>
</template>

<script>

    import ProblemForm from '../views/ProblemForm'
    import LaststepDefault from '../views/LastStep_default'
    import LaststepReturn from '../views/LastStep_Return'
    import Message from '../views/Message'

    export default {
        name: "thirdstep",

        components: {
            ProblemForm,
            LaststepDefault,
            LaststepReturn,
            Message
        },

        computed: {
            view () {

                switch ( this.$store.getters.getReason ){

                    case 'defect':
                        return 'laststep-return'

                    case 'other':
                        return 'message'

                    default:
                        return 'laststep-default'
                }
            }
        }

    }
</script>

<style scoped>

</style>